import React from 'react';

const CustomButton = (props) => {
  const { disabled, children, classname, onButtonClick } = props;

  return (
    <button
      className={`${classname}`}
      onClick={onButtonClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default CustomButton;
